import { cloneDeep } from 'lodash';
import { Settings } from '../interfaces/Settings/Settings';
import { GenericSettingsValue } from '../interfaces/Settings/GenericSettingsValue';
import { SettingsType } from '../interfaces/Settings/SettingsType';

export const getSettingsValue = (
  settings: Settings[],
  key: string,
): GenericSettingsValue | undefined =>
  settings.find((s) => s.key === key)?.genericValue;

export const getUpdatedSettings = (
  settingsType: SettingsType,
  key: string,
  existingSettings: Settings[],
  newValue: GenericSettingsValue,
): Settings[] => {
  const newSettings = cloneDeep(existingSettings);

  const i = existingSettings.findIndex((s) => s.key === key);
  if (i >= 0) {
    newSettings[i].genericValue = newValue;
  } else {
    newSettings.push({
      type: settingsType,
      key,
      createdAt: new Date(),
      updatedAt: new Date(),
      genericValue: newValue,
    });
  }

  return newSettings;
};
